import type {
  NavigationDrawerConfig,
  NavigationDrawerHandle,
} from 'frontend/unpoly/javascripts/navigation_drawer/drawer.svelte'

// The burger button of the A/B test burger_menu. The drawer (a Svelte component shared with the Inertia header)
// is only loaded once the visitor reaches for the button.
up.compiler('[data-navigation-drawer]', (button: HTMLElement, config: NavigationDrawerConfig) => {
  let drawer: NavigationDrawerHandle | undefined
  let destroyed = false

  async function ensureDrawer() {
    if (!drawer) {
      const { useNavigationDrawer } =
        await import('frontend/unpoly/javascripts/navigation_drawer/drawer.svelte')

      if (destroyed || drawer) return drawer

      drawer = useNavigationDrawer(config)
    }
    return drawer
  }

  async function show() {
    ;(await ensureDrawer())?.show(button)
  }

  button.addEventListener('pointerenter', ensureDrawer)
  button.addEventListener('focus', ensureDrawer)
  button.addEventListener('click', show)

  return () => {
    destroyed = true
    drawer?.release()
  }
})
